import { all, fork } from 'redux-saga/effects';

import watchGeoEncodedRequest from './geoEncodedRequest';

function* localizationSagas() {
  yield all([fork(watchGeoEncodedRequest)]);
}

export default localizationSagas;
